export default __webpack_public_path__ + "static/mid6a-1e4651ff6deee187fb508a6c53016ba9.png";